import { useEffect, useState } from 'react'

export const EXAMPLE_REQUESTS = [
   'Call my Zillow leads older than 30 days',
   'New Realtor.com buyers as they come in',
   'Everyone in my Buyer Pond',
   'Sellers tagged investor, not in Sphere',
]

/** The placeholder cycles through examples so the box explains itself. */
export const useCyclingPlaceholder = (active: boolean) => {
   const [i, setI] = useState(0)
   useEffect(() => {
      if (!active) return
      const t = setInterval(() => setI((n) => (n + 1) % EXAMPLE_REQUESTS.length), 3200)
      return () => clearInterval(t)
   }, [active])
   return `Try: “${EXAMPLE_REQUESTS[i]}”`
}
